import { type Psychologist } from '@avanta/shared/types/psychologists';
import { type AppointmentPayload, type Document, type Flow } from 'types/appointments';

export const AppointmentsReservePayload = {
  psychologist: 'psychologist',
  patientId: 'patientId',
  dateTime: 'dateTime',
  backofficeCenterId: 'backofficeCenterId',
  specialityBooked: 'specialityBooked',
  psychologistServiceBooked: 'psychologistServiceBooked',
  observations: 'observations',
  contractId: 'contractId',
  contractRateId: 'contractRateId',
  contractAuthorization: 'contractAuthorization',
  recordFields: 'recordFields',
  //States
  city: 'city',
  flow: 'flow',
  document: 'document',
  hasExpedient: 'hasExpedient',
} as const;

export const AppointmentSteps = {
  patient: 'patient',
  data: 'data',
  session: 'session',
  confirmation: 'confirmation',
  psychologist: 'psychologist',
} as const;

export type Steps = keyof typeof AppointmentSteps;

export type StepProps = {
  nextStepName?: Steps;
  handleNext?: () => void;
  handleBack: (index?: number) => void;
};

export type AppointmentsReserveFormData = {
  psychologist?: Psychologist;
  patientId: string;
  dateTime: string;
  backofficeCenterId: string;
  specialityBooked?: number;
  psychologistServiceBooked?: number;
  observations?: string;
  contractId: string;
  contractRateId: string;
  contractAuthorization: string;
  recordFields: Record<string, string | number | boolean>;
  city: string;
  flow: Flow;
  document?: Document;
  hasExpedient: boolean;
};

export type BookAppointmentVariables = {
  payload: AppointmentPayload;
  document?: Document;
};
